import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import {
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { QueueComponent } from './queue.component';
import { QueueRoutingModule } from './queue-routing.module';
import { QueueBottomComponent } from './queue-bottom/queue-bottom.component';
import { SharedModule } from '@/shared/shared.module';
import { LpxContextMenuModule } from '@volosoft/ngx-lepton-x';
import { LpxClickOutsideModule, LpxNavbarModule } from '@volo/ngx-lepton-x.core';
import { SharedComponentsModule } from '@/components/shared-components.module';
import { SiteModule } from '@/sites/site/site.module';
import { QueueModalsComponent } from './queue-modals/queue-modals.component';

@NgModule({
  declarations: [QueueComponent, QueueBottomComponent, QueueModalsComponent],
  imports: [
    CommercialUiModule,
    CoreModule,
    LpxClickOutsideModule,
    LpxContextMenuModule,
    LpxNavbarModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    PageModule,
    QueueRoutingModule,
    SharedComponentsModule,
    SharedModule,
    ThemeSharedModule,
    SiteModule,
  ],
  exports: [QueueComponent, QueueBottomComponent, QueueModalsComponent],
})
export class QueueModule {}
